module.exports = __webpack_public_path__ + "static/media/ajihmm.638a7051.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/faces/ajihmm.png
// module id = 1648
// module chunks = 0